<template>
    <div>
    <Header></Header>
    <Login></Login>
    <div class="productIntro-list">
        <div class="productIntro-list-item" v-for="(item,index) in productIntroList" :key="index">
            <div class="product-item-info" :style="{background:'url('+item.productIntroItemBg+') 0% 0% / 100% 100%'}">
                <div class="productIntro-item-info-wrapper">
                  <div>
                    <div class="productIntro-item-title">{{item.productIntroItemTitle}}</div>
                    <div class="productIntro-item-title-content">城图房地产数据分析系统，是专为房地产开发商机构量身定制的一款数据软件。<span>整合房地产一、二、三级房地产市场交易数据，还包括一房一价、认筹、认购等行业信息</span>，为房地产开发机构进行城市投资、产品定位、项目营销、课题研究等提供最全面的数据支持。</div>
                  </div>
                  <div class="productIntro-item-img"><img src="../assets/images/productIntro/城图bg@2x.png" /></div>
                </div>
            </div>
            <div class="product-advantage">
                <div class="product-advantage-title">产品优势</div>
                <div class="product-advantage-enTitle">Product Advantages</div> 
                <div class="product-advantage-list">
                    <div class="product-advantage-list-item" v-for="(v,i) in item.productAdvantageList" :key="i">
                        <div class="product-advantage-list-item-wrapper">
                            <div class="product-advantage-img">
                                <img :src="v.productAdvantageIcon" alt="">
                            </div>
                            <div class="product-advantage-text">{{v.productAdvantageTitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-function">
                <div class="product-function-title">产品主要功能</div>
                <div class="product-function-enTitle">The Main Function of The Product</div>
                <div class="product-function-list">
                    <div class="product-function-item" v-for="(vv,ii) in item.productFunctionList" :key="ii">
                        <div class="product-function-item-left">
                            <img :src="vv.productFunctionImgUrl" alt="">
                        </div>
                        <div class="product-function-item-right">
                            <div class="product-function-item-title">{{vv.productFunctionText}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="customer-case">
                <div class="customer-case-title">客户案例</div>
                <div class="customer-case-enTitle">Customer Case</div>
                <div class="customer-case-content" :style="{background:'url('+item.customerCaseBgUrl+') 0% 0% / 100% 100%'}">
                   <div class="customer-case-content-wrapper">
                      <div class="customer-case-content-title">{{item.customerCaseContentTitle}}</div>
                      <div class="customer-case-content-text">{{item.customerCaseContentText}}</div>
                   </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  name: "productIntro",
  components: {
    Header,
    Footer,Login
  },
  data() {
    return {
      productIntroList: [
        {
          id: 1,
          productIntroItemBg: require("../assets/images/productIntro/banner-bg@2x.png"),
          productIntroItemTitle: "城市地图数据分析决策系统",
          productIntroItemContent:
            "城图房地产数据分析系统，是专为房地产开发商机构量身定制的一款数据软件。",
          productAdvantageList: [
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon-chengtu0.png"),
              productAdvantageTitle: "房地产市场详细档案归理"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon-chengtu2.png"),
              productAdvantageTitle: "房地产三级市场打通"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon-chengtu1.png"),
              productAdvantageTitle: "数据可视化"
            }
          ],
          productFunctionList: [
            {
              productFunctionImgUrl: require("../assets/images/productIntro/主要功能-城图@2x.png"),
              productFunctionText:
                "宏观观察、超级地图、土地市场、新房市场、二手房市场"
            }
          ],
          customerCaseBgUrl: require("../assets/images/productIntro/客户案例-城图bg@2x.png"),
          customerCaseContentTitle: "万科地产",
          customerCaseContentText:
            "在系统合作的基础之上，另外合作了楼盘监测、个性化字段定制，用于新房、二手房市场监测，以及产品研究"
        }
      ]
    };
  },
  methods: {},
  created() {}
};
</script>

<style lang="less" scoped>
@import "../assets/css/productIntro.less";
</style>


